import React from 'react'

import { isObject } from 'app/services/object'

import styles from './styles'

const Recommendation = ({recommendation, rangeScore}) => {
  return (
    <>
      {isObject(recommendation) && (
        <p className="card-recommention__info">
          {recommendation[rangeScore]?.text}
        </p>
      )}
      {typeof recommendation === 'string' && (
        <>
          <p className="card-recommendation__title">Recomendación</p>
          <p className="card-recommention__info">{recommendation}</p>
        </>
      )}
      <style jsx>{styles}</style>
    </>
  )
}

export default Recommendation
